class APIS {
	apis() {
		return {
			fetch_template_messages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/fetch/admin'
			},
			fetch_template_analytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/url-shortener/analytics'
			},
			fetch_template_analytics_click_details: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/url-shortener/click-details'
			},
			fetch_template_by_client: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/fetch'
			},
			fetch_campaign_by_client: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/campaign'
			},
			create_campaign_by_client: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/create/campaign'
			},
			update_campaign_by_client: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/update/campaign'
			},
			create_campaign_by_superAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/create/campaign/admin'
			},
			fetch_recipients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients'
			},
			update_recipients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/update'
			},
			create_recipents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/create'
			},
			create_recipents_superAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/create/admin'
			},
			update_recipents_superAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/update/admin'
			},
			delete_campaign_superAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/delete/campaign/admin'
			},
			delete_recipents_superAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/delete/admin'
			},
			delete_recipents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/delete'
			},
			delete_campaign: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/delete/campaign'
			},

			fetch_blacklist: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/template/recipients/blacklist'
			},
			fetchCampaignsSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/campaign/admin'
			},
			fetchNumbersSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/numbers/all'
			},

			createCampaignSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/create/campaign/admin'
			},
			updateCampaignSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/update/campaign/admin'
			},
			createMFMSAPPROVEDSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/create'
			},
			assignTemplateToAgent: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/assign/template/message'
			},
			deleteMFMSAPPROVEDSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/delete/admin'
			},
			sendTemplateMessageSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/create/campaign/admin'
			},
			sendTemplateMessage: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/create/campaign'
			},
			fetchCompletedCampaignsSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/cost/template/admin'
			},
			fetchCompletedAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/cost/template'
			},
			updateMFMSAPPROVEDSuperAdmin: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/template/message/update'
			},

			create_template_message: {
				headers: {
					'xt-user-token': null,
					'Content-Type': 'application/json'
				},
				method: 'post',
				path: '/template/message/create'
			},
			update_template_message: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/template/message/update'
			},
			create_individual_campaign: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/send/template/message/text/admin-only'
			},
			create_individual_campaign_admin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/send/template/message/text'
			},
			getNumberStatus: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/outgoing/message/status'
			},
			getTemplateParams: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/params'
			},
			sendTemplateMsg: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message'
			},
			sendTemplateMsgMarketing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/marketing'
			},
			sendDirectMessage: {
				headers: {
					'xt-user-token': null,
					'Content-Type': 'application/json'
				},
				method: 'post',
				path: '/direct/message'
			},
			retryFailedNumbers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/retry/campaign'
			},
			deleteTemplateFromMeta: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/delete/template/message/:template_name'
			},
			searchByNumber: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/search/number'
			},
			templateNumbersList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/numbers'
				// path: '/template/campaign/numbers'
			},
			fetchRecipientNumbers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipient/numbers'
			},
			fetchOutbox: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/messages'
			},
			exportOutbox: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/download/template/messages'
			},
			downloadCampaign: {
				headers: {
					'xt-user-token': null,
					'Content-Type': 'application/json'
				},
				method: 'post',
				path: '/download/template/campaign'
			},
			changeCampaignStatus: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/change/campaign/status'
			},
			fetchActiveSessions: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/activeSessions'
			},
			getNumStatusforSP: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/outgoing/message/status/admin'
			},
			getOutboxPagination: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/outbox/meta-data'
			},
			stopTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/stop/template/message'
			},
			template_message_journey: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/journey'
			},
			template_summary: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/summary'
			},
			active_session_by_number: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/activeSessionByNumber'
			},
			blockDuplicateClicks: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/message/block-duplicate-clicks'
			},
		};
	}
}

export default new APIS();
